var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        gathererLink: true,
        visible: _vm.$root.$data.gathererLink
    },attrs:{"role":_vm.$root.$data.gathererLink ? 'alert' : '',"aria-hidden":!_vm.$root.$data.gathererLink,"aria-live":"polite"}},[_c('a',{staticClass:"gathererLink--link",attrs:{"href":_vm.$root.$data.gathererLink,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n        View on Scryfall\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }